var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBackGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "goback_greyElement 159") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie",
    "data-name": "Isolationsmodus Kopie"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "container",
    d: "M25.98953,13.38752A12.81135,12.81135,0,0,1,12.952,26c-.1693,0-.33916-.0028-.51069-.00895A12.6668,12.6668,0,0,1,3.47857,21.772a13.32708,13.32708,0,0,1-3.458-9.6636A13.1871,13.1871,0,0,1,13.7124.014,12.65487,12.65487,0,0,1,25.98953,13.38752Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner",
    d: "M14.9859,19.60465Q11.85474,16.46887,8.72357,13.333a.655.655,0,0,1,0-.91159q2.94961-2.95407,5.89929-5.908a.64451.64451,0,0,1,.91032.91159L10.089,12.8772,15.89622,18.693A.64454.64454,0,0,1,14.9859,19.60465Z",
    fill: "#000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackGrey);
export default __webpack_public_path__ + "static/media/go_back_grey.4a0ac9e9033ef84006454dc7050de61b.svg";
export { ForwardRef as ReactComponent };